import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  introduce: {
    title: 'Professional, accurate, and efficient 3D reconstruction',
    price: 'USD 1799',
    dec: 'High-accuracy 3D space camera, with 12K HD resolution, supports 4× zoom and virtual strolling across 720° in the space.',
    btn: 'Buy it on Alibaba',
    subTitle: 'Bring Space to Life in Digital 3D',
    benefitGroup: [
      {
        fontImg: 'icon-qiumu',
        title: '8 spherical <br/>lenses'
      },
      {
        fontImg: 'icon-sfm',
        title: 'AI Space Reconstruction<br/> Algorithm'
      },
      {
        fontImg: 'icon-3d',
        title: 'Automatic 3D <br/>reconstruction'
      },
      {
        fontImg: 'icon-bianji',
        title: 'Produce interactive <br/>video'
      },
      {
        fontImg: 'icon-liulan',
        title: 'Compatible with <br/>all platforms'
      }
    ]
  },
  app: {
    title: '4DKankan App',
    sub: ['快速编辑和分享你的互动式视频', '分享你的空间故事']
  },
  definition: {
    title: '12K HD Resolution and Virtual Strolling across 720° of the Space',
    top: {
      dec:
          ['4DKanKan Pro records three-dimensional information of space, andproduces realistic 3D digital spaces, allowing you to enter anytime',
            'and freely explore as you were there. Never miss a detail with 12K HD resolution and 4x magnification.',
            ''],
      intro: '4DKanKan Pro achieves a high image resolution up to 12,288 × 6,144 pixels.'

    },
    bottom: {
      title: '细节之处，纤毫毕现',
      dec: ['4DKanKan Pro 从视觉外观到握持手感，再到机身防护，无处不凝聚匠心巧思。', '以Pro的独特性作为设计理念，以想象力的创意概念作为设计亮点。', '精湛工艺，细致耐用，细节之处，纤毫毕现。'],
      params2: [
        {
          icon: baseUrl + 'images/icon1.png',
          txt: '实时分享实训世界的所有惊喜。如今，360度图像可实现即时串流！'
        },
        {
          icon: baseUrl + 'images/icon2.png',
          txt: '使用专用智能手机应用程式，拍摄的同事检查曝光和白平衡。'
        },
        {
          icon: baseUrl + 'images/icon3.png',
          txt: '快门速度的设定范围为1/6400秒'
        },
        {
          icon: baseUrl + 'images/icon4.png',
          txt: '静态图像：（大）约1600'
        }
      ]
    }
  },
  hardware: [
    {
      title: ['汇聚一线精湛科技与工艺']
    },
    {
      title: ['HiSilicon Camera Chip', 'High picture quality, low bit rate, and low power consumption.']
    },
    {
      title: ['8 High-definition Spherical Lenses', 'Innovative optical design, better adapting to shooting environments.']
    },
    {
      title: ['SONY CMOS 图像传感器']
    },
    {
      title: ['4-hour Continuous Shooting', 'Huge power in compact and portable design. Record space anytime and anywhere.']
    }
  ],
  feature: {
    definition: {
      title: 'Image Quality',
      case1: {
        content: baseUrl + 'video/8k.mp4',
        back: baseUrl + 'video/4k.mp4',
        lTxt: '4DKanKan Lite',
        rTxt: '4DKanKan Pro',
        lMask: 'High-definition of 4K',
        rMask: '12K HD picture with 4-times magnification'
      }
    },
    ranging: {
      title: ['Distance Measurements', '更极致的空间还原度'],
      sub: 'Show distance measurements',
      hide: 'Hide distance measurements'
    },
    model: {
      title: ['Space Structure', '更极致的空间还原度'],
      case2: {
        content: baseUrl + 'video/qingxi.mp4',
        back: baseUrl + 'video/moku.mp4',
        lTxt: '4DKanKan Lite',
        rTxt: '4DKanKan Pro'
      }
    },
    manyou: {
      title: ['Structural Model', '更极致的空间还原度'],
      left: '4DKanKan Lite',
      right: '4DKanKan Pro'
    },
    endurance: {
      title: '续航时间'
    }
  },
  technology: {
    title: 'The Beauty of Technology from Within',
    dec: 'Powered by the integrated work of hundreds of sophisticated parts, 4DKanKan Pro is light and compact, portable and durable, <br/>and can capture space in 3D for you at any time.'
  },
  parmas: {
    name: 'Detailed Parameters of 4DKanKan Pro'
  },
  standardGroup: {
    label: 'Model',
    name: '4DKanKan Pro',
    info: [{
      label: 'Height',
      value: '220.7mm'
    }, {
      label: 'Width',
      value: '78.2mm'
    }, {
      label: 'Depth',
      value: '78.2mm'
    }],
    params1: [{
      label: 'Lens',
      value: ['Type: 200° fisheye lens', 'Aperture: f/2.0', 'Number: 8', 'Resolution: 4608*3456 pixels(each);<br/>12288*6144 pixels(total)']
    }, {
      label: 'Sensor',
      value: ['Dimension: 1/2.3"', 'Number: 8']
    }, {
      label: 'Storage',
      value: ['16GB']
    }],
    params2: [{
      label: 'Battery',
      value: ['7.4V 4200mAh', 'Quick charge through USB']
    }, {
      label: 'WiFi',
      value: ['802.11a/b/g/n', '2.4/5GHz communication']
    }, {
      label: 'USB Interface',
      value: ['TYPE C']
    }]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/eight.js